<template>
  <div class="invoice-ticket">
    <div class="header">
      <div class="serial">
        <p v-if="data.invoiceCode">{{ $t('fms_invoice_ticket.fa_piao_liu_shui_hao') }}： {{ data.invoiceCode }}</p>
        <p v-if="data.gmtCreate">{{ $t('fms_invoice_ticket.shen_qing_ri_qi') }}：{{ $momentLocal(data.gmtCreate, 'YYYY-MM-DD') }}</p>
      </div>
      <h2>{{ getDicValue('invoice_type_and_class', `${data.invoiceType}_${data.invoiceClass}`) }}</h2>
      <div class="date" v-if="data.invoiceState === 10 && (data.invoiceNum || data.invoiceTime)">
        <h3 v-if="data.invoiceNum">No {{ data.invoiceNum }}</h3>
        <p v-if="data.invoiceTime">{{ $t('fms_invoice_ticket.kai_piao_ri_qi') }}：{{ $momentLocal(data.invoiceTime, 'YYYY-MM-DD') }}</p>
      </div>
    </div>
    <div class="main">
      <div class="purchaseArea">
        <div class="purchaser">
          <div class="title">{{ $t('fms_invoice_ticket.gou_mai_fang') }}</div>
          <div class="name">
            <p>
              {{ $t('fms_invoice_ticket.ming') }} {{ $t('fms_invoice_ticket.cheng') }}：
              <span>{{ data.buyerName }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.nsrsbh') }}：
              <span>{{ data.buyerNumber }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.di_zhi') }}、{{ $t('fms_invoice_ticket.dian_hua') }}：
              <span>{{ data.buyerRegisterAddress }} {{ data.buyerMobile }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.khhjzh') }}：
              <span>{{ data.buyerDepositBank }} {{ data.buyerDepositNumber }}</span>
            </p>
          </div>
        </div>
        <div class="passwordArea">
          <div class="title">{{ $t('fms_invoice_ticket.mi_ma_qu') }}</div>
          <div class="hidden"></div>
        </div>
      </div>
      <div class="order">
        <ul>
          <li class="theader">
            <div>{{ $t('fms_invoice_ticket.hwhyslw') }}、{{ $t('fms_invoice_ticket.fu_wu_ming_cheng') }}</div>
            <div>{{ $t('fms_invoice_ticket.gui_ge_xing_hao') }}</div>
            <div>{{ $t('fms_invoice_ticket.dan_wei') }}</div>
            <div>{{ $t('fms_invoice_ticket.shu_liang') }}</div>
            <div>{{ $t('fms_invoice_ticket.dan_jia') }}</div>
            <div>{{ $t('fms_invoice_ticket.jin_e') }}</div>
            <div>{{ $t('fms_invoice_ticket.shui_lv') }}</div>
            <div>{{ $t('fms_invoice_ticket.shui_e') }}</div>
          </li>
          <li class="line" v-for="item in data.invoiceItemList" :key="item.billId">
            <!-- {{ service_name}} -->
            <div>
              <!-- {{ getDicValue('service_name',item.itemName) }} -->
              {{ item.itemName }}
            </div>
            <div>{{ item.itemSpec }}</div>
            <div>{{ item.itemUnit }}</div>
            <div>{{ formatTicketNumber(item.itemNum) }}</div>
            <div>{{ toFixed2(item.itemPrice / (1 + item.taxRate / 100)) }}</div>
            <div>
              {{ toFixed2(ticketValue((item.itemPrice * item.itemNum) / (1 + item.taxRate / 100))) }}
              <!-- {{ (item.itemAmount - item.taxAmount).toFixed(2) }} -->
            </div>
            <div>{{ item.taxRate }}%</div>
            <div>
              {{ toFixed2(ticketValue(((item.itemPrice * item.itemNum) / (1 + item.taxRate / 100)) * (item.taxRate / 100))) }}
            </div>
          </li>
          <li class="total">
            <div>{{ $t('fms_invoice_ticket.he_ji') }}</div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>{{ formatCurrency(totalAmount) }}</div>
            <div></div>
            <div>{{ formatCurrency(totaltaxAmount) }}</div>
          </li>
        </ul>
      </div>
      <div class="total-tax">
        <div class="tax-title">{{ $t('fms_invoice_ticket.jia_shui_he_ji') }}（{{ $t('fms_invoice_ticket.da_xie') }}）</div>
        <div class="tax-left">{{ formatCapitalAmount(data.invoiceAmount) }}</div>
        <div class="tax-right">（{{ $t('fms_invoice_ticket.xiao_xie') }}）{{ formatCurrency(data.invoiceAmount) }}</div>
      </div>
      <div class="sales">
        <div class="seller">
          <div class="title">{{ $t('fms_invoice_ticket.xiao_shou_fang') }}</div>
          <div class="name">
            <p>
              {{ $t('fms_invoice_ticket.ming') }} {{ $t('fms_invoice_ticket.cheng') }}：
              <span>{{ data.sellerName }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.nsrsbh') }}：
              <span>{{ data.sellerNumber }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.di_zhi') }}、{{ $t('fms_invoice_ticket.dian_hua') }}：
              <span>{{ data.sellerRegisterAddress }} {{ data.sellerMobile }}</span>
            </p>
            <p>
              {{ $t('fms_invoice_ticket.khhjzh') }}：
              <span>{{ data.sellerDepositBank }} {{ data.sellerDepositNumber }}</span>
            </p>
          </div>
        </div>
        <div class="remark">
          <div class="title">{{ $t('Common.com_remark') }}</div>
          <div class="text">
            {{ data.invoiceRemark }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    type: { type: Boolean, default: false },
  },
  computed: {
    invoiceTime: function () {
      return moment(this.data.invoiceTime).format('YYYY-MM-DD');
    },
    totalAmount: function () {
      // return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + next.itemAmount, 0)) || 0;
      return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + (next.itemPrice * next.itemNum) / (1 + next.taxRate / 100).toFixed(2), 0)) || 0;
    },
    totaltaxAmount: function () {
      // return (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + next.taxAmount, 0)) || 0;
      return (
        (this.data.invoiceItemList && this.data.invoiceItemList.reduce((sum, next) => sum + ((next.itemPrice * next.itemNum) / (1 + next.taxRate / 100)).toFixed(2) * (next.taxRate / 100), 0)) || 0
      );
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    ticketValue(value) {
      if (value === undefined || value === null || value === '') {
        return value;
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value;
      }
      return this.type ? -num : num;
    },
    formatTicketNumber(value) {
      const num = this.ticketValue(value);
      return typeof num === 'number' ? num : value;
    },
    formatCurrency(value) {
      const num = this.ticketValue(value);
      if (num === undefined || num === null || num === '' || Number.isNaN(Number(num))) {
        return '';
      }
      const amount = Number(num);
      const sign = amount < 0 ? '-' : '';
      return `${sign}￥${Math.abs(amount).toFixed(2)}`;
    },
    formatCapitalAmount(value) {
      const num = this.ticketValue(value);
      if (num === undefined || num === null || num === '' || Number.isNaN(Number(num))) {
        return '';
      }
      const amount = Number(num);
      return this.$t('fms_invoice_ticket.oo', [amount < 0 ? this.$t('fms_invoice_ticket.fu') : '',this.$moneyToCapital(Math.abs(amount))]);
    },
    toFixed2(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value;
      }
      return num.toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.invoice-ticket {
  // width: 925px;
  border: 1px solid #800000;
  margin: 0 auto 20px;
  padding: 0 48px 20px;
  min-width: 1100px;
  .header {
    text-align: center;
    position: relative;
    height: 118px;
    border-left: 1xp solid #800000;
    border-right: 1xp solid #800000;
    h2 {
      color: #9f5008;
      padding-bottom: 10px;
      border-bottom: 1px solid #800000;
      letter-spacing: 3px;
      border-bottom-style: double;
      border-bottom-width: 4px;
      display: inline-block;
      text-align: center;
      font-size: 28px;
      line-height: 40px;
      margin-top: 32px;
    }
    .serial {
      position: absolute;
      left: 0;
      bottom: 25px;
      color: #000000;
      text-align: left;
      p {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        // letter-spacing:1px;
      }
    }
    .date {
      position: absolute;
      right: 0;
      bottom: 25px;
      color: #000000;
      text-align: right;
      h3 {
        height: 25px;
        font-size: 18px;
        padding-bottom: 8px;
        line-height: 25px;
        letter-spacing: 1px;
      }
      p {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
  }
  .main {
    color: #9f5008;
    border-left: 1px solid #800000;
    border-right: 1px solid #800000;
    border-bottom: 1px solid #800000;
    .purchaseArea {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .purchaser {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          p {
            padding: 3px 0;
            font-size: 12px;
            span {
              color: #000000;
            }
          }
        }
      }
      .passwordArea {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .hidden {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
        }
      }
    }
    .order {
      li {
        display: flex;

        div {
          padding: 0 10px;
          flex: 1;
          border: 1px solid #800000;
          border-bottom: 0;
          border-left: 0;
          border-top: 0;
          text-align: center;
          // border-right:0
        }
        div:first-of-type {
          flex: 0 0 200px;
        }
        div:last-of-type {
          border-right: 0;
        }
      }

      .theader {
        border-top: 1px solid #800000;
        height: 35px;
        line-height: 35px;
        font-size: 12px;
      }
      .line {
        // padding-top:6px;
        color: #000000;
        line-height: 17px;
        font-size: 12px;
        div {
          padding-top: 6px;
        }
      }
      .total {
        height: 50px;
        line-height: 70px;
        color: #000000;
        div:first-of-type {
          color: #9f5008;
        }
      }
    }
    .total-tax {
      height: 36px;
      line-height: 36px;
      display: flex;
      div {
        border: 1px solid #800000;
        border-left: 0;
        border-bottom: 0;
        border-right: 0;
      }
      .tax-title {
        flex: 0 0 200px;
        border-right: 1px solid #800000;
        text-align: center;
      }
      .tax-left {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
      .tax-right {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
    }
    .sales {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .seller {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
        }
        p {
          padding: 3px 0;
          font-size: 12px;
          span {
            color: #000000;
          }
        }
      }
      .remark {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .text {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
          color: #000000;
        }
      }
    }
  }
  .footer {
    border-top: 1px solid #800000;
    line-height: 36px;
    color: #9f5008;
    span {
      color: #000000;
    }
  }
}
</style>
